import { SITE_URL } from '../../constants'
import { buildCaseStudySchema } from '../../builders/caseStudy'
import { PageMeta } from '../../types'

const description = "新たな事業アイデアを創出するワークショップを実施しました。このワークショップは中期経営方針を実現するために、全体最適実現のためのアイデアを網羅的に創出しました。イノベーション理論を用いたワークを行い、30個以上のアイデアを出しデジタルプロジェクト進行の支援まで実施しました。"

const primaryImage = "https://www.i3design.jp/ogp_logo.png"

export const kayabaPageMeta: PageMeta = {
  title: "イノベーション ワークショップ | 事例 | i3DESIGN アイスリーデザイン",
  description,
  keyword: "DX戦略 組織開発 人材育成 生成AI デジタルトランスフォーメーション",
  image: primaryImage,
  url: `${SITE_URL}/cases/kayaba/`,
}

export const kayabaSchema = buildCaseStudySchema({
  slug: "kayaba",
  pageTitle: kayabaPageMeta.title,
  description: kayabaPageMeta.description,
  headline: "イノベーション ワークショップ",
  alternativeHeadline: "カヤバ株式会社",
  primaryImage,
  images: ["https://www.i3design.jp/ogp_logo.png","https://www.i3design.jp/images/img/cases/caseStudyTop/kayaba.webp"],
  clientName: "カヤバ株式会社",
  breadcrumbLabel: "イノベーション ワークショップ",
})
